const n={config:{alignment:"center",size:"content",link:{target:"_blank",rel:""}}};export{n as DEFAULTS};
//# sourceMappingURL=defaults.js.map
